import { gsap } from "gsap";

function withPreloader(el, init) {
  // Если прелоадер уже завершился — сразу инициализируем
  if (window.__preloaderFinished) {
    init();
    return;
  }

  const handler = () => {
    init();
    window.removeEventListener("app-preloader-finished", handler);
  };

  window.addEventListener("app-preloader-finished", handler);
  el.__gsapPreloaderHandler = handler;
}

export function registerGsapDirectives(app) {
  // Базовый fade-up для блоков / карточек
  app.directive("gsap-fade-up", {
    beforeMount(el, binding) {
      const options = binding.value || {};
      const delay = options.delay ?? 0;
      const duration = options.duration ?? 0.8;
      const offset = options.offset ?? 40;

      gsap.set(el, { opacity: 0, y: offset });

      const initAnimation = () => {
        if (el.__gsapObserver) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                gsap.to(el, {
                  opacity: 1,
                  y: 0,
                  duration,
                  delay,
                  ease: "power3.out",
                  onComplete: () => {
                    observer.disconnect();
                  },
                });
              }
            });
          },
          { threshold: 0.15 }
        );

        el.__gsapObserver = observer;
        observer.observe(el);
      };

      withPreloader(el, initAnimation);
    },
    unmounted(el) {
      if (el.__gsapObserver) {
        el.__gsapObserver.disconnect();
        delete el.__gsapObserver;
      }
      if (el.__gsapPreloaderHandler) {
        window.removeEventListener(
          "app-preloader-finished",
          el.__gsapPreloaderHandler
        );
        delete el.__gsapPreloaderHandler;
      }
    },
  });

  // Премиальная анимация заголовков: покадровое появление букв
  app.directive("gsap-heading", {
    beforeMount(el, binding) {
      const options = binding.value || {};
      const duration = options.duration ?? 1.2;
      const delay = options.delay ?? 0;
      const stagger = options.stagger ?? 0.04;

      const text = el.textContent || "";
      el.innerHTML = "";

      const letters = [];
      for (const char of text) {
        const span = document.createElement("span");
        span.classList.add("gsap-heading-letter");
        span.textContent = char === " " ? "\u00A0" : char;
        el.appendChild(span);
        letters.push(span);
      }

      gsap.set(letters, {
        opacity: 0,
        yPercent: 120,
        rotateX: 35,
        skewY: 10,
      });

      const initAnimation = () => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const tl = gsap.timeline();
              tl.to(letters, {
                opacity: 1,
                yPercent: 0,
                rotateX: 0,
                skewY: 0,
                duration,
                ease: "power4.out",
                stagger,
                delay,
              });

              observer.disconnect();
            });
          },
          { threshold: 0.25 }
        );

        el.__gsapObserver = observer;
        observer.observe(el);
      };

      withPreloader(el, initAnimation);
    },
    unmounted(el) {
      if (el.__gsapObserver) {
        el.__gsapObserver.disconnect();
        delete el.__gsapObserver;
      }
      if (el.__gsapPreloaderHandler) {
        window.removeEventListener(
          "app-preloader-finished",
          el.__gsapPreloaderHandler
        );
        delete el.__gsapPreloaderHandler;
      }
    },
  });

  // Анимация для круглых аватарок (TEAM)
  app.directive("gsap-avatar", {
    beforeMount(el, binding) {
      const options = binding.value || {};
      const delay = options.delay ?? 0;
      const duration = options.duration ?? 0.9;

      gsap.set(el, {
        opacity: 0,
        scale: 0.7,
        y: 24,
        rotate: -6,
        filter: "blur(6px)",
      });

      const initAnimation = () => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              const tl = gsap.timeline();
              tl.to(el, {
                opacity: 1,
                scale: 1,
                y: 0,
                rotate: 0,
                filter: "blur(0px)",
                duration,
                ease: "power3.out",
                delay,
              }).to(
                el,
                {
                  scale: 1.03,
                  y: -4,
                  duration: 1.4,
                  ease: "sine.inOut",
                  yoyo: true,
                  repeat: -1,
                },
                "-=0.4"
              );

              observer.disconnect();
            });
          },
          { threshold: 0.3 }
        );

        el.__gsapObserver = observer;
        observer.observe(el);
      };

      withPreloader(el, initAnimation);
    },
    unmounted(el) {
      if (el.__gsapObserver) {
        el.__gsapObserver.disconnect();
        delete el.__gsapObserver;
      }
      if (el.__gsapPreloaderHandler) {
        window.removeEventListener(
          "app-preloader-finished",
          el.__gsapPreloaderHandler
        );
        delete el.__gsapPreloaderHandler;
      }
    },
  });
}

